// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "w_rH d_gv d_cs";
export var heroHeaderCenter = "w_gw d_gw d_cs d_dw";
export var heroHeaderRight = "w_gx d_gx d_cs d_dx";
export var heroParagraphLeft = "w_rJ d_gr d_cw";
export var heroParagraphCenter = "w_gs d_gs d_cw d_dw";
export var heroParagraphRight = "w_gt d_gt d_cw d_dx";
export var heroBtnWrapperLeft = "w_rK d_d2 d_d1 d_w d_bz d_bG";
export var heroBtnWrapperCenter = "w_rL d_d3 d_d1 d_w d_bz d_bD";
export var heroBtnWrapperRight = "w_rM d_d4 d_d1 d_w d_bz d_bH";
export var overlayBtnWrapper = "w_rN d_gq d_0 d_7 d_8 d_9 d_bn d_cc";
export var design4 = "w_rP d_gp d_0 d_7 d_8 d_bn";
export var heroExceptionSmall = "w_rQ G_rQ";
export var heroExceptionNormal = "w_rR G_rR";
export var heroExceptionLarge = "w_rS G_rS";
export var Title1Small = "w_rT G_rT G_sX G_sY";
export var Title1Normal = "w_rV G_rV G_sX G_sZ";
export var Title1Large = "w_rW G_rW G_sX G_s0";
export var BodySmall = "w_rX G_rX G_sX G_tf";
export var BodyNormal = "w_rY G_rY G_sX G_tg";
export var BodyLarge = "w_rZ G_rZ G_sX G_th";